/**
 * @module explore/components/projects
 */
import React, { Component, PropTypes } from 'react';
import ProjectsPage from 'explore/components/projects_page';
import ExploreCTA from 'explore/components/explore_cta';
import Pager from 'common/pager/containers';
import { getCanonicalURL, hasAPIQueryStringChanged } from 'common/utils';
import { Meta } from 'common/components/meta';
import {
  trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
  MP_CLICKED_GET_STARTED_EVENT_NAME, MP_CLICKED_HOW_IT_WORKS_EVENT_NAME
} from 'common/tracking';
import ProjectsControls from 'explore/containers/projects_controls';
import AppliedFilters from 'explore/containers/projects_applied_filters';
import { PROJECTS_RESOURCE_NAME } from 'explore/constants';

/**
 * Main component for the explore projects
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class ExploreProjects extends Component {
  componentDidMount() {
    this.fetchData();
    trackMixpanel(
      MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
      {
        "pageName": "Explore"
      }
    )
    trackMixpanel("Viewed explore", {"group": "Projects"});
  }

  componentDidUpdate(prevProps) {
    /* re-fetch resource if filter/sorting/search/etc query parameters have changed */
    if (hasAPIQueryStringChanged(PROJECTS_RESOURCE_NAME, prevProps, this.props)) {
      this.props.fetchProjects();
    }
  }

  fetchData() {
    const { fetchProjects, fetchIndustriesIfNeeded } = this.props;
    fetchProjects();
    fetchIndustriesIfNeeded();
  }

  renderProjects() {
    const {
      projectsFetching, industriesFetching, projectsState, categories, industries, user,
      fetchProjects
    } = this.props;
    const isFetching = projectsFetching || industriesFetching;

    return (
      <ProjectsPage
        projects={projectsState.data}
        categories={categories}
        industries={industries}
        fetching={isFetching}
        user={user}
      />
    );
  }

  renderCTA() {
    const { projectsState, user } = this.props;

    if (!user.logged_in && projectsState.data.length) {
      return <ExploreCTA
        getStartedEventTracking={{
          eventName: MP_CLICKED_GET_STARTED_EVENT_NAME,
          eventData: {
            pageName: "Project explorer",
            pageArea: "CTA",
          }
        }}
        howItWorksEventTracking={{
          eventName: MP_CLICKED_HOW_IT_WORKS_EVENT_NAME,
          eventData: {
            pageName: "Project explorer",
            pageArea: "CTA",
          }
        }}

        />;
    }

    return null;
  }

  render() {
    const { fetchProjects } = this.props;

    return (<div className="explore-page">
      <Meta
        title="Explore Logos, Graphic Design, Product Design, and Naming Projects"
        meta={[
          { name: 'description', content: 'Looking for graphic or logo design contests or projects? Check these out from our 60,000+ clients and launch your own today. 100% money-back guarantee!' },
          { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' },
          { property: 'og:title', content: `crowdspring projects` },
          { property: 'og:url', content: getCanonicalURL(`/explore/`) },
        ]}
        link={[{ rel: 'canonical', href: getCanonicalURL('/explore/') }]}
      />
      { this.renderCTA() }

      <section className="explore-results">
        <div className="row">
          <div className="columns small-16 large-12">
            <AppliedFilters />
          </div>
        </div>
        <div className="row">
          { this.renderProjects() }

          <div className="show-for-large medium-4 columns">
            <ProjectsControls />
          </div>
        </div>
      </section>
      <div className="row">
        <div className="columns medium-12">
          <Pager resourceName={PROJECTS_RESOURCE_NAME} />
        </div>
      </div>
    </div>);
  }
}

ExploreProjects.propTypes = {
  projectsState: PropTypes.object,
  categories: PropTypes.array,
  projectsFetching: PropTypes.bool,
  user: PropTypes.shape({
    logged_in: PropTypes.bool,
  }),
  fetchProjects: PropTypes.func,
  fetchIndustriesIfNeeded: PropTypes.func,
  industries: PropTypes.any,
  industriesFetching: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./explore/components/projects.jsx